import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import smoothscroll from 'smoothscroll-polyfill';
import 'swiper/css';

import { getEnvVar } from '#shared/envs';
import { injectLink, injectMeta, injectContentSquare } from '#shared/utils/head';
import { injectGTM, injectGTMNoScript } from '#shared/utils/tagmanager';

import Router from '#quote/Router';

const App: React.FC = () => {
  useEffect(() => {
    smoothscroll.polyfill();
  }, []);

  return (
    <>
      <Helmet>
        {injectLink()}
        <title>{getEnvVar('VITE_TITLE_APP')}</title>
        {injectMeta()}
        {injectGTM()}
        {injectContentSquare()}
      </Helmet>
      {injectGTMNoScript()}
      <Router />
    </>
  );
};

export default App;
